import React from 'react'
import { DocumentNode } from 'graphql'
import { PureQueryOptions } from 'apollo-client'
import { SessionMetadataAggregation } from './index'
import { AggregationOptions } from '../aggregations'
import { Query } from 'react-apollo'

interface ChildProps {
  readonly sessionMetadataAggregations: SessionMetadataAggregation[]
  readonly loading: boolean
  readonly queryInfo: PureQueryOptions
}

interface Props<TAggregationCategory extends string> {
  readonly query: DocumentNode
  readonly organizationID: string
  readonly quickFilter?: string
  readonly filterText?: string
  readonly aggregationFilters: AggregationOptions<TAggregationCategory>
  readonly additionalFilters?: { readonly [key: string]: any }

  readonly children: (props: ChildProps) => React.ReactNode
}

interface VarsWithoutAgg {
  readonly organizationID: string
  readonly quickFilter?: string
  readonly filterText?: string
}

type Vars<TAggregationCategory extends string> = VarsWithoutAgg &
  AggregationOptions<TAggregationCategory>

export function SessionMetadataAggregationLoader<
  TAggregationCategory extends string
>({
  query,
  organizationID,
  quickFilter,
  filterText,
  aggregationFilters,
  additionalFilters,
  children
}: Props<TAggregationCategory>) {
  const variables: Vars<TAggregationCategory> = Object.assign(
    {},
    aggregationFilters,
    {
      organizationID,
      quickFilter,
      filterText,
      ...additionalFilters
    }
  )

  return (
    <Query<{
      readonly sessionMetadataAggregations: SessionMetadataAggregation[]
    }>
      fetchPolicy="network-only"
      query={query}
      variables={variables}
    >
      {({ loading, data }) =>
        children({
          sessionMetadataAggregations:
            (data && data.sessionMetadataAggregations) || [],
          loading,
          queryInfo: {
            query,
            variables
          }
        })
      }
    </Query>
  )
}
